/**
 * Component for displaying SVG icons from SVGL.
 * Supports both inline SVG and SVG files.
 */

import React from 'react';
import { Box, SxProps, Theme, useTheme } from '@mui/material';

interface SvgIconProps {
  iconName: string;
  size?: number;
  color?: string;
  sx?: SxProps<Theme>;
  variant?: 'light' | 'dark';
}

const SvgIcon: React.FC<SvgIconProps> = ({
  iconName,
  size = 24,
  color,
  sx,
  variant,
}) => {
  const theme = useTheme();
  const isDark = theme.palette.mode === 'dark';
  const iconVariant = variant || (isDark ? 'dark' : 'light');
  
  // Map of icon names to their SVG file paths
  const iconMap: Record<string, string> = {
    mysql: '/icons/mysql.svg',
    postgresql: '/icons/postgresql.svg',
  };

  const iconPath = iconMap[iconName] || `/icons/${iconName}.svg`;

  return (
    <Box
      component="img"
      src={iconPath}
      alt={iconName}
      sx={{
        width: size,
        height: size,
        objectFit: 'contain',
        filter: color ? `brightness(0) saturate(100%) ${color}` : undefined,
        ...sx,
      }}
    />
  );
};

export default SvgIcon;



